import type { LocaleProps } from "@/types";
import { Inter as loadInterFont } from "next/font/google";
import { defaultLocale } from "@/config";
import clsx from "clsx";

import { CookieBanner } from "@/providers/cookies";
import { TrustpilotScript } from "@/providers/trust";
import { AppsFlyerProvider } from "@/providers/onelink";
import { GoogleGtmHead, GoogleGtmBody } from "@/providers/gooogle";

import "@/ui/theme.css";


// should it be in app/**/layout.tsx?
const interFont = loadInterFont({
  variable: "--font-inter",
  subsets: ["latin"],

  weight: ["300", "400", "500", "600", "700"],
  display: "swap",
});


export function BaseLayout(props: Readonly<LocaleProps & {
  children?: React.ReactNode;
  bodyClassName?: string;
}>) {
  return (
    <html lang={props.nonStandardLocale?.code ?? props.locale ?? defaultLocale}>
      <head>
        <GoogleGtmHead />
        <link rel="apple-touch-icon" sizes="180x180" href="/apple-touch-icon.png" />
        <link rel="icon" type="image/png" sizes="32x32" href="/favicon-32x32.png" />
        <link rel="icon" type="image/png" sizes="16x16" href="/favicon-16x16.png" />
        <link rel="icon" href="/favicon.ico" type="image/x-icon" sizes="any" />
        <AppsFlyerProvider />
        <TrustpilotScript />
      </head>
      <body className={clsx(`${interFont.variable} antialiased`, props.bodyClassName)}>
        <GoogleGtmBody />
        <CookieBanner />
        {props.children}
      </body>
    </html>
  );
}
